var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"position":"relative","top":"205px","left":"0","text-align":"center"}},[_vm._v(" "+_vm._s(_vm.unit)+" ")]),_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.getChartOption(),"loading":_vm.loading,"theme":_vm.isDarkTheme? 'dark' : 'light',"group":_vm.group}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }